<template>
  <div>
    <div class="card" v-if="selected">
      <header class="card-header">
        <p
          v-if="selected.card"
          class="card-header-title"
        >
          {{selected.card.name}}, {{selected.card.phone}}, {{selected.card.id}}
          <a
            v-if="selected.card_id && false"
            class="mgl-1 button is-small is-warning"
          >20 грн кешбака</a>
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div
          class="content"
        >{{findProgram(selected.service_id, 'price') }}, {{selected.rounded_weight}}кг - {{selected.price}}грн</div>
        <div class="content" v-if="selected">
          <b-field label="Актуальна вага - заокруглена - вартість - кількість пакетів">
            <div class="columns">
              <div class="column">
                <b-input type="number" v-model="weight" placeholder="Вес на вагах"></b-input>
              </div>
              <div class="column">
                <b-input type="number" v-model="rounded_weight" placeholder="Вес закругленный"></b-input>
              </div>
              <div class="column">
                <b-input v-model="price" placeholder="Cумма к оплате"></b-input>
              </div>
              <div class="column">
                <b-input v-model="parts" placeholder="Количество пакетов"></b-input>
              </div>
            </div>
          </b-field>
          <b-field>
            <b-select placeholder="Select a name" v-model="selectedService">
              <option
                v-for="(option, index) in services"
                :value="option"
                :key="index"
              >{{ option.name }}</option>
            </b-select>
          </b-field>
          <b-field label="Статус">
            <b-select placeholder="Select a name" v-model="status">
              <option
                v-for="(option, index) in statuses"
                :value="option"
                :key="index"
              >{{ option.value }}</option>
            </b-select>
          </b-field>
          <b-field label="Оплата">
            <b-select placeholder="Select a name" v-model="paid">
              <option
                v-for="(option, index) in paids"
                :value="option"
                :key="index"
              >{{ option.value }}</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <footer class="card-footer">
        <a class="card-footer-item" @click="saveItem">Сохранить</a>
        <a @click="removeId" class="card-footer-item is-danger">Удалить</a>
        <!-- <a href="#" class="card-footer-item">Delete</a> -->
      </footer>
    </div>
    <pre>{{ selected }}</pre>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: ["selected", "services"],
  data() {
    return {
      selectedService: null,
      weight: null,
      rounded_weight: null,
      price: null,
      parts: null,
      status: null,
      paid: null,
      paids: [
        {
          id: 0,
          value: 'Не оплачено'
        },{
          id: 1,
          value: 'готівка'
        },{
          id: 2,
          value: 'Картка'
        }
      ],
      statuses: [
        {
          id: 0,
          value: 'В роботі'
        },{
          id: 1,
          value: 'Готово до видачі'
        },{
          id: 2,
          value: 'Завершено'
        }
      ]
    }
  },
  watch: {
    'selected': 'changeService'
  },
  methods: {
    ...mapActions(['removeProcesses', 'editProcesses']),
    findProgram(x, v) {
      let find = this.services.find(({ id }) => id == x);
      if (find && v == "name") return find.name;
      if (find && v == "price") return find.price;
      return find || null;
    },
    async removeId() {
      await this.removeProcesses({id: this.selected.id}).then(() => {
        this.$emit('removed')
      })
    },
    changeService() {
      this.selectedService = this.findProgram(this.selected.service_id)
      this.weight = this.selected.weight
      this.rounded_weight = this.selected.rounded_weight
      this.price = this.selected.price
      this.parts = this.selected.parts
      this.status = this.statuses.find(({id}) => id == this.selected.status)
      this.paid = this.paids.find(({id}) => id == this.selected.paid)
    },
    saveItem() {
      this.editProcesses({
        method: 'post',
        process: {
          weight: this.weight,
          rounded_weight: this.rounded_weight,
          price: this.price,
          parts: this.parts,
          service_id: this.selectedService.id,
          status: this.status.id,
          paid: this.paid.id
        },
        point: `processes/${this.selected.id}`
      }).then(() => {
        this.$emit('removed')
        this.$buefy.snackbar.open({
          duration: 5000,
          message: 'Готово',
          position: 'is-top'
        })
      })
    },
  }
};
</script>

